import { useCallback, useState } from 'react';
import { useApi } from '../../api/ApiContext';
import { ApiError } from '../../api/client';
import { useMapPreview } from '../../map/MapPreviewContext';

/**
 * Henter første side med features for et datasett (esri-format) og legger dem
 * som forhåndsvisning i kartet. Brukes fra både kobling- og datasett-panelet.
 */
export function useDatasetPreview() {
    const { client } = useApi();
    const { setPreview } = useMapPreview();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [activeId, setActiveId] = useState<string | null>(null);

    const preview = useCallback(
        async (system: string, datasetId: string, title: string) => {
            setIsLoading(true);
            setError(null);
            setActiveId(datasetId);
            try {
                const result = await client.getDatasetFeatures(system, datasetId);
                setPreview({
                    title,
                    result,
                    wkid: result.metadata.spatialReferenceWkid,
                });
                if (result.features.length === 0) {
                    setError('Datasettet ga ingen features å vise.');
                }
            } catch (err) {
                const message = err instanceof ApiError ? err.message : 'Kunne ikke hente features.';
                setError(message);
            } finally {
                setIsLoading(false);
            }
        },
        [client, setPreview],
    );

    return { preview, isLoading, error, activeId };
}
